import { create } from 'zustand';


interface Toast {
  visible: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}
interface ToastStore {
  toast: Toast;
  showToast: (message: string, severity?: Toast['severity']) => void;
  hideToast: () => void;
}


const useToastStore = create<ToastStore>((set) => ({
  toast: {
    visible: false,
    message: '',
    severity: 'info',
  },
  showToast: (message, severity = 'info') =>
    set({
      toast: { visible: true, message, severity },
    }),
  hideToast: () =>
    set({
      toast: { visible: false, message: '', severity: 'info' },
    }),
}));

export default useToastStore;
